/**
===================================================
Module: frontend.src.components.ResetPassword.tsx
Description: Password reset component that handles email links with code
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * This component handles password reset links from email.
 * If code and email are in URL params, it redirects to login with those params
 * so the user can enter their new password.
 */
const ResetPassword: React.FC = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get("code");
    const email = searchParams.get("email");

    if (code && email) {
      // Redirect to login with reset password mode and pre-filled code
      navigate(`/login?mode=resetPassword&code=${encodeURIComponent(code)}&email=${encodeURIComponent(email)}`, { replace: true });
    } else {
      // No code/email, redirect to login with forgot password mode (standard for welcome emails)
      navigate("/login?mode=forgotPassword", { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <div className="login-container">
      <div className="login-card">
        <p>{t('resetPassword.redirectingToReset')}</p>
      </div>
    </div>
  );
};

export default ResetPassword;
